import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=1485b765"
import script from "./SubCategories.vue?vue&type=script&lang=ts"
export * from "./SubCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports